import {
	paymentArrangementRegex,
	paymentPlanRegex,
	secureCodeRegex,
	optOutRegex,
	transactionalEmailOptOutRegex,
} from "./routeExtractionRegexs"

const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Extract token parameter from opt-out routes
 * Patterns:
 * - /opt-out/:token/:channel/*
 * - /transactional-email-opt-out/:token
 */
const extractOptOutToken = (pathname: string): string | undefined => {
	const optOutMatch = pathname.match(optOutRegex)
	const transactionalMatch = pathname.match(transactionalEmailOptOutRegex)

	if (optOutMatch) {
		return optOutMatch[1]
	}

	if (transactionalMatch) {
		return transactionalMatch[1]
	}

	return undefined
}

/**
 * Extract paymentPlanID parameter from payment plan routes with hardcoded regions or secure codes
 * Patterns:
 * - /0/payment-plan/:paymentPlanID, /1/payment-plan/:paymentPlanID, /2/payment-plan/:paymentPlanID
 * - /X-XXXX-XXXX/payment-plan/:paymentPlanID (secure code format)
 * Returns undefined if the extracted ID is not a valid UUID
 */
const extractPaymentPlanID = (pathname: string): string | undefined => {
	// First try the existing region-based regex
	const regionMatch = pathname.match(paymentPlanRegex)
	if (regionMatch) {
		const paymentPlanID = regionMatch[3]
		return uuidRegex.test(paymentPlanID) ? paymentPlanID : undefined
	}

	// Then try secure code-based pattern: /X-XXXX-XXXX/payment-plan(-status)?/:paymentPlanID
	const secureCodePaymentPlanRegex =
		/^\/([A-Z0-9]-[A-Z0-9]{4}-[A-Z0-9]{4}|[A-Z0-9]{4}-[A-Z0-9]{4})\/payment-plan(-status)?\/([^/]+)(?:\/.*)?$/
	const secureCodeMatch = pathname.match(secureCodePaymentPlanRegex)
	if (secureCodeMatch) {
		const paymentPlanID = secureCodeMatch[3]
		return uuidRegex.test(paymentPlanID) ? paymentPlanID : undefined
	}

	return undefined
}

/**
 * Extract payment arrangement ID from payment arrangement route
 * Pattern: /:region/payment-arrangement/:paymentArrangementID
 * Returns undefined if the extracted ID is not a valid UUID
 */
const extractPaymentArrangementParams = (pathname: string): string | undefined => {
	const regex = paymentArrangementRegex
	const match = pathname.match(regex)

	if (match) {
		const paymentArrangementID = match[2]
		return uuidRegex.test(paymentArrangementID) ? paymentArrangementID : undefined
	}

	return undefined
}

/**
 * Extract secureCode parameter from secure code routes
 * Pattern: /X-XXXX-XXXX/* where X is a number or letter
 */
const extractSecureCodeParams = (pathname: string): string | undefined => {
	const regex = secureCodeRegex
	const match = pathname.match(regex)

	if (match) {
		return match[1]
	}

	return undefined
}

export {extractOptOutToken, extractPaymentPlanID, extractPaymentArrangementParams, extractSecureCodeParams}
